<template>
  <q-fila v-if="aplica" :label="label" :ayuda="ayuda" :completa="respondida" :resaltar="resaltar">
    <textarea class="form-control" rows="2" :placeholder="placeholder"
              :value="value" :disabled="soloLectura"
              @input="$emit('input', $event.target.value)"></textarea>
  </q-fila>
</template>

<script>
import QFila from "./QFila";

/** Detalle en texto libre, normalmente asociado a una opción "Otro:". */
export default {
  name: "QTexto",
  components: { QFila },
  props: {
    value: { default: null },
    label: { type: String, required: true },
    ayuda: { type: String, default: "" },
    placeholder: { type: String, default: "Detalle..." },
    aplica: { type: Boolean, default: true },
    resaltar: { type: Boolean, default: true },
    soloLectura: { type: Boolean, default: false },
  },
  computed: {
    respondida() {
      return this.value != null && String(this.value).trim().length > 0;
    },
  },
};
</script>
